/**
 * @generated SignedSource<<8f732e3796702512c73ca832a7914491>>
 * @relayHash 7a443acd220d539f3cd8c7ec5c956659
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 325aa048001f18db849e4eab37f49af8b128234d4f44f3212d79bc71a67833c7

import type { ConcreteRequest, Query } from 'relay-runtime';
export type sidebarSelectorQuery$variables = {
  cloudId: string;
  isSkipped: boolean;
};
export type sidebarSelectorQuery$data = {
  readonly jira?: {
    readonly navigationUIState: {
      readonly isLeftSidebarCollapsed: boolean | null | undefined;
      readonly leftSidebarWidth: number | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type sidebarSelectorQuery = {
  response: sidebarSelectorQuery$data;
  variables: sidebarSelectorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isSkipped"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "isLeftSidebarCollapsed"
},
v3 = {
  "kind": "ScalarField",
  "name": "leftSidebarWidth"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "sidebarSelectorQuery",
    "selections": [
      {
        "condition": "isSkipped",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v1/*: any*/),
                "concreteType": "JiraNavigationUIStateUserProperty",
                "kind": "LinkedField",
                "name": "navigationUIState",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sidebarSelectorQuery",
    "selections": [
      {
        "condition": "isSkipped",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v1/*: any*/),
                "concreteType": "JiraNavigationUIStateUserProperty",
                "kind": "LinkedField",
                "name": "navigationUIState",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "325aa048001f18db849e4eab37f49af8b128234d4f44f3212d79bc71a67833c7",
    "metadata": {},
    "name": "sidebarSelectorQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "08b2edadb724d5a59e6adfbb10f7a3a4";

export default node;
